
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startCategoriaXID, startListadoCategorias } from "../../../services";






export const useCategoriaXID = (id) => {
    const categoriaXIDQuery = useQuery({
        queryKey: ['categoria-id', id], 
        queryFn: () => startCategoriaXID(id),
    });

    return { categoriaXIDQuery }
}





export const useCategoriasQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const categoriasQuery = useQuery({
        queryKey: ['categorias-list', { page, termino }], 
        queryFn: () => startListadoCategorias({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        categoriasQuery,
    }
}
